import columns from '../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NumberColumn,
    PercentageColumn,
  } = columns(data);

  return [
    {
      Header: 'Operator',
      columns: [
        new TextColumn('Operator From', 'operator.from').withTotalHeader('Total'),
        new TextColumn('Operator To', 'operator.to'),
      ],
    },
    {
      Header: 'Route',
      columns: [
        new TextColumn('IMPC From', 'route.impcFrom'),
        new DateTimeColumn('IMPC To', 'route.impcTo'),
      ],
    },
    {
      Header: 'Small',
      columns: [
        new NumberColumn('Pallet Boxes', 'cdata.small.asset').withTotalHeader(sumTotal),
        new NumberColumn('Total', 'cdata.small.total').withTotalHeader(sumTotal),
        new PercentageColumn('%', 'cdata.small.pct').withTotalHeader(totalRowRatio(['cdata.small.asset', 'cdata.small.total'])),
      ],
    },
    {
      Header: 'Large',
      columns: [
        new NumberColumn('Pallet Boxes', 'cdata.large.asset').withTotalHeader(sumTotal),
        new NumberColumn('Total', 'cdata.large.total').withTotalHeader(sumTotal),
        new PercentageColumn('%', 'cdata.large.pct').withTotalHeader(totalRowRatio(['cdata.large.asset', 'cdata.large.total'])),
      ],
    },
    {
      Header: 'Mix Small & Large',
      columns: [
        new NumberColumn('Pallet Boxes', 'cdata.mix.asset').withTotalHeader(sumTotal),
        new NumberColumn('Total', 'cdata.mix.total').withTotalHeader(sumTotal),
        new PercentageColumn('%', 'cdata.mix.pct').withTotalHeader(totalRowRatio(['cdata.mix.asset', 'cdata.mix.total'])),
      ],
    },
    {
      Header: 'Other',
      columns: [
        new NumberColumn('Pallet Boxes', 'cdata.other.asset').withTotalHeader(sumTotal),
        new NumberColumn('Total', 'cdata.other.total').withTotalHeader(sumTotal),
        new PercentageColumn('%', 'cdata.other.pct').withTotalHeader(totalRowRatio(['cdata.other.asset', 'cdata.other.total'])),
      ],
    },
    {
      Header: 'Not defined',
      columns: [
        new NumberColumn('Pallet Boxes', 'cdata.notDefined.asset').withTotalHeader(sumTotal),
        new NumberColumn('Total', 'cdata.notDefined.total').withTotalHeader(sumTotal),
        new PercentageColumn('%', 'cdata.notDefined.pct').withTotalHeader(totalRowRatio(['cdata.notDefined.asset', 'cdata.notDefined.total'])),
      ],
    },
  ];
};
